export default __webpack_public_path__ + "static/media/WebCoding.3933ec56.svg";